import { Paper, TableContainer } from "@mui/material"
import { useAppDispatch, useAppSelector } from "../../../app/hooks"
import { DataGrid, GridColDef } from "@mui/x-data-grid"
import { useLocalization } from "@fluent/react"
import { enUS, plPL } from "@mui/x-data-grid/locales"
import { selectSettings } from "../../settings/settingsSlice"
import { Supplier } from "../../suppliers/suppliersSlice"
import { useEffect } from "react"
import { loadCompanies, selectAllCompanies, selectCompanies } from "../companiesSlice"
import { QuickSearchToolbar } from "../../../app/QuickSearchToolbar"

interface SuppliersDataGridProps {
    suppliers: Supplier[];
    onRowSelected: (rowId: string) => void;
}

export const SuppliersDataGrid:React.FC<SuppliersDataGridProps> = ({ suppliers, onRowSelected }) => {
    const { l10n } = useLocalization()
    const { locale } = useAppSelector(selectSettings);
    const dispatch = useAppDispatch();
    const { loaded } = useAppSelector(selectCompanies);
    const companies = useAppSelector(selectAllCompanies);

    useEffect(() => {
        if (!loaded) {
            dispatch(loadCompanies())
        }
    }, [dispatch, loaded]);

    const getCustomLocaleText = () => {
        const defaultEnLocaleText = enUS.components.MuiDataGrid.defaultProps.localeText;

        if (locale === 'pl') {
            return plPL.components.MuiDataGrid.defaultProps.localeText;
        } else {
            return defaultEnLocaleText;
        }
    };

    const handleSelectionChange = (selectionModel) => {
        onRowSelected(selectionModel[0]);
    };

    const columns: GridColDef<Supplier, any, any>[] = [
        {
            field: 'name',
            headerName: l10n.getString("company-supplier-mappings-supplier-name", null, "_Nazwa dostawcy"),
            flex: 1,
        },
        {
            field: 'shortName',
            headerName: l10n.getString("company-supplier-mappings-supplier-short-name", null, "_Skrócona nazwa dostawcy"),
            flex: 1,
        },
        {
            field: 'email',
            headerName: l10n.getString("company-supplier-mappings-supplier-email", null, "_E-mail dostawcy"),
            flex: 1,
        },
        {
            field: 'companyId',
            headerName: l10n.getString("company-supplier-mappings-contact-owner", null, "_Właściciel kontaktu (firma zarejestrowana)"),
            flex: 1,
            valueGetter: (_, row) => {
                const company = companies.find(f => f.id === row.companyId);
                return company ? company.name : "";
            }
        },
    ]

    return (
        <TableContainer component={Paper}>
            <DataGrid localeText={getCustomLocaleText()}
                style={{ minHeight: 100, height: 'calc(100vh - 350px)' }}
                rows={suppliers}
                columns={columns}
                initialState={{
                    sorting: { sortModel: [{ field: 'name', sort: 'desc' }] }
                }}
                slots={{ toolbar: QuickSearchToolbar }}
                onRowSelectionModelChange={handleSelectionChange}
            />
        </TableContainer>
    )
}
